/* eslint-disable */
import React from 'react';
import isEqual from 'lodash/isEqual';
import { KEYS } from '@/utils/constants';
import modalStyles from './Modal.css';

let modalStack = [];

let openModal = function(template, showCloseCross, disableDismiss) {
  let templateExists = false;

  if (modalStack.length > 0) {
    modalStack.forEach(item => {
      if (isEqual(item.template, template)) {
        templateExists = true;
      }
    });
  }

  if (!templateExists) {
    const modalObj = { template, showCloseCross };
    modalStack.push(modalObj);
  }
  this.setState({
    show: true,
    template,
    showCloseCross: !!showCloseCross,
    disableDismiss: !!disableDismiss,
  });
  // eslint-disable-next-line no-unused-expressions
  this.modalContainer && this.modalContainer.focus();
};

let hideModal = function(closeAllOpenModals, disableDismiss) {
  if (!disableDismiss) {
    if (modalStack.length > 1 && !!closeAllOpenModals === false) {
      modalStack.pop();
      openModal(
        modalStack[modalStack.length - 1].template,
        modalStack[modalStack.length - 1].showCloseCross
      );
    } else {
      modalStack = [];
      this.setState({
        template: null,
        show: false,
      });
    }
  }
};

class Modal extends React.Component {
  constructor(props) {
    super(props);
    openModal = openModal.bind(this);
    hideModal = hideModal.bind(this);
  }

  state = {
    show: false,
    template: null,
  };

  componentDidMount() {
    document.body.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = e => {
    const { keyCode } = e;
    const { disableDismiss, template } = this.state;

    if (keyCode === KEYS.ESCAPE && template) {
      if (!disableDismiss) {
        hideModal();
      }
      e.stopPropagation();
    }
  };

  render() {
    const { show, template, showCloseCross, disableDismiss } = this.state;
    if (!show) {
      return null;
    }
    return (
      <div
        className={modalStyles.overlay}
        onClick={() => hideModal(false, disableDismiss)}
        role='button'
        tabIndex='-1'
        onKeyDown={() => {}}
      >
        <div
          className={modalStyles.modal_content}
          onClick={event => event.stopPropagation()}
          ref={div => {
            this.modalContainer = div;
          }}
          role='button'
          tabIndex='-1'
          onKeyDown={() => {}}
        >
          {showCloseCross && (
            <div
              className={modalStyles.close_button}
              onClick={() => hideModal()}
              role='button'
              tabIndex='-1'
              onKeyDown={() => {}}
            />
          )}
          {template}
        </div>
      </div>
    );
  }
}

export { openModal, hideModal };

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js